import '../../assets/index30.css';var h = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var x = Object.prototype.hasOwnProperty, T = Object.prototype.propertyIsEnumerable;
var p = (e, n, r) => n in e ? h(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r, c = (e, n) => {
  for (var r in n || (n = {}))
    x.call(n, r) && p(e, r, n[r]);
  if (i)
    for (var r of i(n))
      T.call(n, r) && p(e, r, n[r]);
  return e;
};
var m = (e, n) => {
  var r = {};
  for (var a in e)
    x.call(e, a) && n.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && i)
    for (var a of i(e))
      n.indexOf(a) < 0 && T.call(e, a) && (r[a] = e[a]);
  return r;
};
import { jsxs as j, jsx as s } from "react/jsx-runtime";
import { forwardRef as v } from "react";
import { ErrorMessage as $ } from "../../molecules/ErrorMessage/index.js";
import { T as y } from "../../Textarea-LPIXpNZY.js";
const B = "InlineTextarea-module__root___FYrlU", D = "InlineTextarea-module__wrapper___DefLK", E = "InlineTextarea-module__inlineTextareaRoot___I5YuT", F = "InlineTextarea-module__inlineTextarea___pg0am", U = "InlineTextarea-module__error___WBFD0", Y = "InlineTextarea-module__supportingText___UoSfj", z = "InlineTextarea-module__description___N-Ow2", t = {
  root: B,
  wrapper: D,
  inlineTextareaRoot: E,
  inlineTextarea: F,
  error: U,
  supportingText: Y,
  description: z
}, C = v(
  (L, N) => {
    var _ = L, {
      defaultValue: e,
      disabled: n,
      placeholder: r = "Inline textarea",
      onChange: a,
      value: d,
      className: u,
      width: I,
      error: o,
      description: l,
      minRows: f = 2,
      maxRows: w = 5
    } = _, g = m(_, [
      "defaultValue",
      "disabled",
      "placeholder",
      "onChange",
      "value",
      "className",
      "width",
      "error",
      "description",
      "minRows",
      "maxRows"
    ]);
    const R = !!o;
    return /* @__PURE__ */ j("div", { className: t.inlineTextareaRoot, children: [
      /* @__PURE__ */ s(
        y,
        c({
          disabled: n,
          value: d,
          defaultValue: e,
          onChange: a,
          placeholder: r,
          autosize: !0,
          minRows: f,
          maxRows: w,
          classNames: {
            root: t.root,
            wrapper: t.wrapper,
            input: `${t.inlineTextarea} ${u || ""} ${R ? t.error : ""}`
          },
          style: { width: I },
          ref: N
        }, g)
      ),
      (l || o) && /* @__PURE__ */ s("div", { className: t.supportingText, children: o ? /* @__PURE__ */ s($, { error: o }) : /* @__PURE__ */ s("div", { className: t.description, children: l }) })
    ] });
  }
), K = C;
K.displayName = "InlineTextarea";
export {
  K as InlineTextarea
};
